import { useCallback, useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { getParentOrigin } from '../utils/post-message';
// Listen for `sdk_exception` events sent from mobile SDKs whenever an unhandled
// exception occurs, and log the stacktrace to Datadog.
export var useSDKExceptionListener = function () {
    var eventListener = useCallback(function (event) {
        if (!event.data)
            return;
        if (typeof event.data !== 'object')
            return;
        var dataType = event.data.type;
        var eventName = 'eventName' in event.data ? event.data.eventName : null;
        var parentOrigin = getParentOrigin();
        if (dataType === 'PINWHEEL_INTERNAL_COMM_DOWN' &&
            eventName === 'sdk_exception') {
            if (parentOrigin && event.origin !== parentOrigin) {
                datadogLogs.logger.warn("Link received 'sdk_exception' event from an untrusted origin (".concat(event.origin, ")"));
                return;
            }
            var stackTrace = event.data.payload.stackTrace;
            datadogLogs.logger.error('sdk_exception', {
                stack_trace: stackTrace,
            });
        }
    }, []);
    useEffect(function () {
        window.addEventListener('message', eventListener);
        return function () { return window.removeEventListener('message', eventListener); };
    }, [eventListener]);
};
